import { Card } from "@/components/ui/card";
import { fmtOrEmpty } from "@/lib/format";
import { AlertTriangle } from "lucide-react";

const STATUS_CLS = { FINAL: "bg-emerald-100 text-emerald-800", SEMENTARA: "bg-amber-100 text-amber-800" };

function Box({ label, value, testid, cls = "text-navy", sub }) {
  return (
    <div className="rounded-md border p-3">
      <div className="text-xs text-muted-foreground">{label}</div>
      <div className={`font-bold ${cls}`} data-testid={testid}>{value}</div>
      {sub && <div className="text-[10px] text-muted-foreground mt-0.5">{sub}</div>}
    </div>
  );
}

export const FinancialSummary = ({ h }) => {
  const laba = h.laba_kotor;
  const noDeal = !h.deal_exists;
  const taxSub = h.tax_mode ? `${h.tax_mode}${h.ppn_percent ? ` ${h.ppn_percent}%` : ""}` : "Pajak: BELUM DITENTUKAN";
  return (
    <Card className="p-4" data-testid="financial-summary">
      <div className="flex items-center justify-between flex-wrap gap-2 mb-3">
        <h3 className="font-heading font-semibold text-navy text-sm">Ringkasan Keuangan Proyek</h3>
        <span className={`text-[10px] font-semibold px-2.5 py-1 rounded-full ${STATUS_CLS[h.profit_status] || "bg-slate-100 text-slate-700"}`} data-testid="fin-profit-status">{h.profit_status}</span>
      </div>
      <div className="grid grid-cols-2 md:grid-cols-5 gap-3">
        <Box label="Total Nilai Kontrak" value={noDeal ? "BELUM DEAL" : fmtOrEmpty(h.contract_total)} testid="fin-contract" sub={noDeal ? null : `${h.deal_locked ? "Terkunci" : "Belum dikunci"} · ${taxSub}`} />
        <Box label="Pendapatan sebelum PPN" value={noDeal ? "BELUM DEAL" : fmtOrEmpty(h.revenue_dpp, "BELUM DITENTUKAN")} testid="fin-dpp" />
        <Box label="RAP (Rencana)" value={fmtOrEmpty(h.rap_plan)} testid="fin-rab" sub="Bahan + Sparepart + Jasa" />
        <Box label="HPP Aktual" value={fmtOrEmpty(h.hpp_actual)} testid="fin-hpp" />
        <Box label="Laba Kotor" value={laba == null ? "BELUM DAPAT DIHITUNG" : fmtOrEmpty(laba)} testid="fin-laba"
          cls={laba == null ? "text-slate-500 text-sm" : laba < 0 ? "text-red-600" : "text-emerald-700"}
          sub={h.margin_percent != null ? `Margin ${h.margin_percent}%` : "Margin tidak dihitung"} />
      </div>
      {h.profit_status === "SEMENTARA" && (
        <div className="mt-3 flex items-center gap-2 text-xs text-amber-800 bg-amber-50 border border-amber-200 rounded-md px-3 py-2" data-testid="fin-provisional">
          <AlertTriangle size={14} /> Laba & margin bersifat SEMENTARA. Final setelah proyek Closed dan seluruh biaya aktual tercatat.
        </div>
      )}
      <div className="mt-2 text-[11px] text-muted-foreground" data-testid="fin-payments">Histori pembayaran: BELUM TERISI (modul pembayaran belum tersedia).</div>
    </Card>
  );
};
